import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../js/coreRuntime.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../Unit.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import {
  Random24dxadk52mliy as Random,
  takeUpperBits23varjnd7v1uz as takeUpperBits,
} from './Random.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function checkInvariants($this) {
  // Inline function 'kotlin.require' call
  if (!!(($this.cr_1 | $this.dr_1 | $this.er_1 | $this.fr_1 | $this.gr_1) === 0)) {
    var message = 'Initial state must have at least one non-zero element.';
    throw IllegalArgumentException().a1(toString(message));
  }
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        this.jr_1 = 0n;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var XorWowRandomClass;
function XorWowRandom() {
  if (XorWowRandomClass === VOID) {
    class $ extends Random() {
      static kr(x, y, z, w, v, addend) {
        var $this = this.zq();
        $this.cr_1 = x;
        $this.dr_1 = y;
        $this.er_1 = z;
        $this.fr_1 = w;
        $this.gr_1 = v;
        $this.hr_1 = addend;
        checkInvariants($this);
        // Inline function 'kotlin.repeat' call
        var inductionVariable = 0;
        if (inductionVariable < 64)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            $this.ul();
          }
           while (inductionVariable < 64);
        return $this;
      }
      static ir(seed1, seed2) {
        return this.kr(seed1, seed2, 0, 0, ~seed1, seed1 << 10 ^ (seed2 >>> 4 | 0));
      }
      ul() {
        var t = this.cr_1;
        t = t ^ (t >>> 2 | 0);
        this.cr_1 = this.dr_1;
        this.dr_1 = this.er_1;
        this.er_1 = this.fr_1;
        var v0 = this.gr_1;
        this.fr_1 = v0;
        t = t ^ t << 1 ^ v0 ^ v0 << 4;
        this.gr_1 = t;
        this.hr_1 = this.hr_1 + 362437 | 0;
        return t + this.hr_1 | 0;
      }
      ar(bitCount) {
        return takeUpperBits(this.ul(), bitCount);
      }
    }
    initMetadataForClass($, 'XorWowRandom');
    XorWowRandomClass = $;
  }
  return XorWowRandomClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  XorWowRandom as XorWowRandom4dcuf9lla8j1,
};
//endregion

//# sourceMappingURL=XorWowRandom.mjs.map
